import * as application from './application';
import * as destinations from './destinations';
import * as occupations from './occupations';
import * as industries from './industries';
import * as channels from './channels';
import * as customer from './customer';
import * as trackingLink from './trackingLink';
import * as content from './content';
import * as signposts from './signposts';
export {
  application,
  destinations,
  occupations,
  industries,
  channels,
  customer,
  trackingLink,
  content,
  signposts,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/data/api/transformers/index.ts